import React, { useEffect, useState } from "react";
import Reveal from "./Reveal";
import { TokenETH, TokenUSDT } from "@token-icons/react";
import {
  useAppKit,
  useAppKitAccount,
  useWalletInfo,
} from "@reown/appkit/react";
import {
  PreSaleAddress,
  PreSaleWagamiContract,
  USDTWagamiContract,
  TokenAddress,
} from "../contracts/contracts";
import BigNumber from "bignumber.js";
import { toast } from "react-toastify";
import Countdown from "react-countdown";
import {
  useReadContract,
  useBalance,
  useWriteContract,
  useWatchAsset,
} from "wagmi";
import { sendPurchaseData } from "../utils/sendPurchaseData";
import CustomCountDown from "./CustomCountDown";
import { sendData } from "../utils/sendData";
import { useSearchParams } from "react-router-dom";

const tokenInfo = [
  {
    name: "ETH",
    icon: <TokenETH className="text-blue-400" />,
    address: "",
    native: false,
  },
  {
    name: "USDT",
    icon: <TokenUSDT className="text-green-600" />,
    address: "",
    native: false,
  },
];

const Slider = () => {
  const { open, close } = useAppKit();
  const [prices, setprices] = useState({ USDT: 0, ETH: 0 });
  const [balances, setbalances] = useState({ USDT: 0, ETH: 0 });
  const [pay, setpay] = useState();
  const [buyAmount, setbuyAmount] = useState();
  const [completed, setCompleted] = useState();
  const [presaleRewards, setpresaleRewards] = useState([]);
  const [loading, setloading] = useState(false);
  const [reciveAmount, setreciveAmount] = useState();
  const [searchParams] = useSearchParams();
  const [selectedToken, setselectedToken] = useState("ETH");
  const [event, setEvent] = useState(null);
  const { address, isConnected, caipAddress, status, embeddedWalletInfo } =
    useAppKitAccount();

  useEffect(() => {
    getData();
    getEvent();
  }, []);

  async function getEvent() {
    try {
      const res = await fetch("https://api.filetrust.io/api/user/event");
      const data = await res.json();
      setEvent(data?.data);
    } catch (err) {
      console.error("Failed to fetch event info", err);
    }
  }

  async function getData() {
    const result = await fetch("https://api.filetrust.io/api/tasks");
    const data = await result.json();
    setpresaleRewards(data?.data?.presaleReward);
  }

  function calculatePoints(amountInUSDEntring) {
    if (amountInUSDEntring > 0 && amountInUSDEntring <= 20)
      return presaleRewards[0];
    if (amountInUSDEntring > 20 && amountInUSDEntring <= 50)
      return presaleRewards[1];
    if (amountInUSDEntring > 50 && amountInUSDEntring <= 200)
      return presaleRewards[2];
    if (amountInUSDEntring > 200 && amountInUSDEntring <= 500)
      return presaleRewards[3];
    if (amountInUSDEntring > 500 && amountInUSDEntring <= 1000)
      return presaleRewards[4];
    if (amountInUSDEntring > 1000) return presaleRewards[5];
    return 0;
  }

  const { walletInfo } = useWalletInfo();

  const { watchAsset } = useWatchAsset();

  const { data: ethPrice, isLoading: ethLoading } = useReadContract({
    ...PreSaleWagamiContract,
    functionName: "calculateEthRequired",
    args: [1000000000000000000n],
  });
  const { data: usdtPrice, isLoading: usdtLoading } = useReadContract({
    ...PreSaleWagamiContract,
    functionName: "calculateUsdtRequired",
    args: [1000000000000000000n],
  });

  const { data: usdtBalance, isFetched: usdtBalanceFetched } = useReadContract({
    ...USDTWagamiContract,
    functionName: "balanceOf",
    args: [address],
  });

  const { data: usdtAllowance } = useReadContract({
    ...USDTWagamiContract,
    functionName: "allowance",
    args: [address, PreSaleAddress],
  });

  const {
    data: hash,
    writeContract,
    error,
    isPending,
    isSuccess,
  } = useWriteContract();

  const { data: ethBalance, isFetched: ethBalanceFetched } = useBalance({
    address,
  });

  useEffect(() => {
    if (!usdtLoading && !ethLoading) {
      getPrices();
    }
  }, [usdtLoading]);

  useEffect(() => {
    if (ethBalanceFetched && usdtBalanceFetched) {
      getBalances();
    }
  }, [usdtBalanceFetched]);

  async function getPrices() {
    if (usdtPrice && ethPrice) {
      const tokenPerUSDT = new BigNumber(usdtPrice).div(
        new BigNumber(10).pow(6)
      );
      const tokenPerEth = new BigNumber(ethPrice).div(
        new BigNumber(10).pow(18)
      );
      setprices({ USDT: tokenPerUSDT.toNumber(), ETH: tokenPerEth.toNumber() });
    }
  }

  async function getBalances() {
    const tokenPerUSDT = new BigNumber(usdtBalance.toString()).div(
      new BigNumber(10).pow(6)
    );
    const tokenPerEth = new BigNumber(ethBalance.value.toString()).div(
      new BigNumber(10).pow(18)
    );
    setbalances({ USDT: tokenPerUSDT.toNumber(), ETH: tokenPerEth.toNumber() });
  }

  async function handleChangeAmount(event) {
    const value = event.target.value;
    setbuyAmount(value);
    if (selectedToken === "ETH") {
      const newPrice = (1 * value) / Number(prices.ETH);
      setreciveAmount(newPrice.toFixed());
    } else if (selectedToken === "USDT") {
      const newPrice = (1 * value) / Number(prices.USDT);
      setreciveAmount(newPrice.toFixed());
    }
  }

  async function handleChangeTokenAmount(event) {
    const value = event.target.value;
    setreciveAmount(value);

    if (value >= 250 && selectedToken === "ETH") {
      const returnValue = value * prices.ETH;
      setbuyAmount(returnValue.toFixed(6));
    } else if (value >= 250 && selectedToken === "USDT") {
      const returnValue = value * prices.USDT;
      setbuyAmount(returnValue.toFixed(6));
    } else {
      setpay(null);
    }
  }

  async function buyToken() {
    if (!address) {
      return toast.error("Connect Your Wallet");
    }
    if (!reciveAmount || !buyAmount) {
      sendPurchaseData(
        reciveAmount ? reciveAmount : 0,
        walletInfo?.name ? walletInfo?.name : "Undefined",
        "Failed",
        selectedToken,
        address,
        "No Value in Inputs",
        selectedToken === "ETH"
          ? ethBalance.value.toString()
          : usdtBalance?.toString()
      );
      return toast.error("Enter the amount");
    }
    if (reciveAmount < 250) {
      sendPurchaseData(
        reciveAmount ? reciveAmount : 0,
        walletInfo?.name ? walletInfo?.name : "Undefined",
        "Failed",
        selectedToken,
        address,
        "Minimum buy amount is 250",
        selectedToken === "ETH" ? balances.ETH : balances.USDT
      );
      return toast.error("Minimum buy amount is 250");
    }

    if (selectedToken === "USDT") {
      buyTokensWithUSDT();
      // await USDTtoToken(address, buyAmount, reciveAmount, walletInfo?.name);
    } else if (selectedToken === "ETH") {
      buyTokensWithETH();
      // await ETHtoToken(address, buyAmount, reciveAmount, walletInfo?.name);
    }
  }

  async function buyTokensWithETH(params) {
    // تبدیل به BigNumber و ضرب در 10^18
    const newReciveAmount = new BigNumber(reciveAmount)
      .multipliedBy(new BigNumber(10).exponentiatedBy(18))
      .toFixed();
    const newAmount = new BigNumber(buyAmount)
      .multipliedBy(new BigNumber(10).exponentiatedBy(18))
      .toFixed();

    if (Number(newAmount) > Number(ethBalance.value.toString())) {
      sendPurchaseData(
        reciveAmount ? reciveAmount : 0,
        walletInfo?.name ? walletInfo?.name : "Undefined",
        "Failed",
        selectedToken,
        address,
        "No ETH balance",
        selectedToken === "ETH" ? balances.ETH : balances.USDT
      );
      return toast.error("No ETH balance");
    }

    writeContract({
      ...PreSaleWagamiContract,
      functionName: "buyTokensWithETH",
      args: [newReciveAmount],
      value: newAmount,
    });
  }

  async function buyTokensWithUSDT(params) {
    const newReciveAmount = new BigNumber(reciveAmount)
      .multipliedBy(new BigNumber(10).exponentiatedBy(18))
      .toFixed();
    const newAmount = new BigNumber(buyAmount)
      .multipliedBy(new BigNumber(10).exponentiatedBy(6))
      .toFixed();

    if (Number(newAmount) > Number(usdtBalance.toString())) {
      sendPurchaseData(
        reciveAmount || 0,
        walletInfo?.name || "Undefined",
        "Failed",
        selectedToken,
        address,
        "No USDT balance",
        selectedToken === "ETH" ? balances.ETH : balances.USDT
      );
      return toast.error("No USDT balance");
    }

    if (usdtAllowance < newAmount) {
      const approveTx = await writeContract({
        ...USDTWagamiContract,
        functionName: "approve",
        args: [PreSaleAddress, newAmount],
      });
    }

    await writeContract({
      ...PreSaleWagamiContract,
      functionName: "buyTokensWithUSDT",
      args: [newReciveAmount],
    });
  }

  useEffect(() => {
    if (error) {
      toast.error(error?.shortMessage);

      sendPurchaseData(
        reciveAmount ? reciveAmount : 0,
        walletInfo?.name ? walletInfo?.name : "Undefined",
        "Failed",
        selectedToken,
        address,
        error,
        selectedToken === "ETH" ? balances.ETH : balances.USDT
      );
    }
  }, [error]);

  useEffect(() => {
    if (isPending) {
      setloading(true);
      setTimeout(() => {
        setloading(false);
      }, 30000);
    } else {
      setloading(false);
    }
  }, [isPending]);

  useEffect(() => {
    if (hash) {
      const checkTransaction = async () => {
        try {
          const userId = searchParams.get("user");

          if (
            event?.tokenShouldBuy &&
            Number(reciveAmount) >= Number(event.tokenShouldBuy)
          ) {
            try {
              await sendDataEvent({ userId });
              console.log("Event claim submitted");
            } catch (err) {
              toast.error("Data Event Failled");
              console.error("Failed to send event buyed request", err);
            }
          }

          toast.success(`Transaction successful at ${hash}`);

          let amountInUSD = 0;

          if (selectedToken === "ETH") {
            amountInUSD = new BigNumber(buyAmount)
              .multipliedBy(4000)
              .toNumber();
          } else if (selectedToken === "USDT") {
            amountInUSD = Number(buyAmount);
          }

          const points = calculatePoints(amountInUSD);

          sendData(userId, points);
          sendPurchaseData(
            reciveAmount ? reciveAmount : 0,
            walletInfo?.name ? walletInfo?.name : "Undefined",
            "Success",
            selectedToken,
            address,
            "Success",
            selectedToken === "ETH" ? balances.ETH : balances.USDT
          );
        } catch (err) {
          console.error("Transaction confirmation error:", err);
          toast.error("Transaction confirmation failed");
        }
      };

      checkTransaction();
    }
  }, [hash]);

  async function sendDataEvent({ userId }) {
    await fetch("https://api.filetrust.io/api/user/event/buyed", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        tokenAmount: Number(reciveAmount),
        userId: userId,
      }),
    });
  }

  return (
    <div className="relative min-h-[80vh]">
      {loading && (
        <div className="fixed w-full h-full z-50 top-0 left-0 bg-black/50 gap-5 items-center justify-center flex flex-col">
          <div role="status">
            <svg
              aria-hidden="true"
              className="w-40 h-40 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span className="sr-only">Loading...</span>
          </div>
          <button
            onClick={() => setloading(false)}
            className=" px-5 text-white rounded-[8px] py-2 text-center bg-[#0E4079]"
          >
            Cancel
          </button>
        </div>
      )}
      {/* <appkit-button /> */}
      <Reveal>
        <div className="p-3 lg:p-0 grid lg:grid-cols-2 items-center lg:px-32 gap-5">
          <span className="mx-auto font-[Inter] w-full text-[14px] lg:text-[16px] lg:left-[5%] max-w-[430px] border-yellow-500 shadow-2xl border-2 rounded-[12px] bg-slate-800 l backdrop-blur-md flex flex-col items-center justify-center">
            {/* <div
              style={{ textShadow: "1px 1px #000" }}
              className="text-center text-yellow-500 font-bold text-[32px]"
            >
              Presale Ends In:
            </div>
            <CustomCountDown setCompleted={setCompleted} /> */}
            <div className="px-2 py-4 lg:p-4 w-full">
              <span className="bg-black/70 p-3 rounded-[8px] text-white text-center flex flex-col gap-3 w-full">
                <div className="flex justify-center items-center">
                  <div className="text-[12px] lg:text-[14px] w-full">
                    <div className=" px-3 py-2 text-center text-white text-[16px]">
                      FTU Price During ICO
                    </div>
                    <div className="px-3 py-2 text-center text-white w-full grid grid-cols-2 bg-slate-800 border border-slate-700 rounded-md">
                      <span className="text-center ">
                        1 FTU: {prices?.ETH} ETH
                      </span>
                      <span className="text-center border-l">
                        1 FTU: {prices?.USDT} USDT
                      </span>
                    </div>
                  </div>
                </div>
              </span>
              <span className="bg-black/70 p-3 rounded-[8px] text-white text-center flex flex-col gap-3 mt-1">
                <div className="relative text-left w-full">
                  Network:
                  <span className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2 flex gap-1 items-center">
                    <TokenETH className="text-blue-400" /> ETH(ERC20)
                  </span>
                </div>
                <span className="w-full text-center text-[14px]">
                  Buy With:
                </span>
                <div className="grid grid-cols-2 gap-3">
                  {tokenInfo.map((item) => (
                    <button
                      onClick={() => {
                        setbuyAmount("");
                        setreciveAmount("");
                        setpay(null);
                        setselectedToken(item.name);
                      }}
                      className={`${
                        selectedToken == item.name
                          ? "border-yellow-600 bg-zinc-700"
                          : "bg-[#000]/90 border-white"
                      } border   flex gap-2 py-1 text-[14px] rounded-[8px] justify-center items-center`}
                    >
                      {item.icon} {item.name}
                    </button>
                  ))}
                </div>
                <div className="grid grid-cols-2 gap-2">
                  {usdtBalanceFetched && ethBalanceFetched ? (
                    <div className="text-center text-[14px] mb-1 w-full col-span-full border-sec">
                      {selectedToken === "ETH"
                        ? `ETH balance ${balances.ETH}`
                        : `USDT balance ${balances.USDT}`}
                    </div>
                  ) : null}

                  <span className="flex flex-col gap-1">
                    <label className="text-[14px] text-left">
                      Pay with {selectedToken}
                    </label>
                    <span className="w-full relative">
                      <input
                        onChange={handleChangeAmount}
                        type="number"
                        value={
                          typeof buyAmount === "number" ? buyAmount : buyAmount
                        }
                        placeholder="0"
                        className="bg-white text-black rounded-md outline p-3 shadow w-full"
                      />
                    </span>
                  </span>
                  <span className="flex flex-col gap-1">
                    <label className="text-[14px] text-left">Recive FTU</label>
                    <input
                      placeholder="min 250"
                      type="number"
                      value={
                        typeof reciveAmount === "number"
                          ? reciveAmount
                          : reciveAmount
                      }
                      onChange={handleChangeTokenAmount}
                      className="bg-white text-black rounded-md outline p-3 shadow "
                    />
                  </span>
                  <div className="text-left text-[14px]  w-full col-span-full">
                    {reciveAmount >= 250
                      ? `You need ${
                          typeof buyAmount === "number"
                            ? buyAmount.toFixed(4)
                            : buyAmount
                        } ${selectedToken} + Network fee`
                      : "Minimum amount is 250 FTU"}
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  <button
                    onClick={() => (address ? open({}) : open({}))}
                    className="w-full rounded-[8px] py-2 text-center bg-[#0E4079] disabled:opacity-45"
                  >
                    {address ? "Account" : "Connect Wallet"}
                  </button>

                  <button
                    onClick={buyToken}
                    disabled={address ? false : true}
                    className="w-full rounded-[8px] py-2 text-center bg-[#0E4079] disabled:opacity-45"
                  >
                    Buy
                  </button>

                  <button
                    onClick={() =>
                      watchAsset({
                        type: "ERC20",
                        options: {
                          address: TokenAddress,
                          symbol: "FTU",
                          decimals: 18,
                          image: "https://buy.filetrust.io/logo.png",
                        },
                      })
                    }
                    disabled={address ? false : true}
                    className="w-full rounded-[8px] py-2 text-center bg-[#0E4079] disabled:opacity-45 hidden lg:block"
                  >
                    Import Token
                  </button>
                </div>
              </span>
            </div>
          </span>

          <span>
            <img
              src="/slider.png"
              class="w-full max-w-[630px]"
              alt="File Trust"
            />
          </span>
        </div>
      </Reveal>
    </div>
  );
};

export default Slider;
